import { app } from './firebaseConfig';
import apiClient from '../shared/utils/apiConfig';
import { showInfoToast } from '../shared/utils/toastHelper';
import { playNotificationSound } from '../shared/utils/notificationSound';

/** يجب أن يطابق topic الإرسال من الباك إند (مثلاً broadcast لكل العملاء). */
export const FCM_ALL_CLIENTS_TOPIC =
  process.env.REACT_APP_FCM_TOPIC || 'all_clients';

/**
 * طلب اختياري: إذا كان الباك إند يعرّف مساراً يسجّل الـ token على الـ topic (بعد تسجيل الدخول).
 * مثال: REACT_APP_FCM_SUBSCRIBE_ENDPOINT=/notifications/fcm/subscribe-topic
 */
const SUBSCRIBE_ENDPOINT = process.env.REACT_APP_FCM_SUBSCRIBE_ENDPOINT || '';

/**
 * الحصول على FCM token للويب (يُستخدم في الاشتراك على topic من السيرفر).
 */
export async function getWebFcmToken() {
  try {
    if (!('serviceWorker' in navigator)) {
      return '';
    }

    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
        { scope: '/' }
      );
    }
    await navigator.serviceWorker.ready;
    if (!registration) {
      return '';
    }

    const { getMessaging, getToken, isSupported } = await import(
      'firebase/messaging'
    );
    const supported = await isSupported();
    if (!supported) {
      return '';
    }

    const messaging = getMessaging(app);
    const vapidKey =
      process.env.REACT_APP_FIREBASE_VAPID_KEY ||
      'BGKiTkA1ytW1AC2TdHTG6eSNQDSHgEVeFZT6m7t8hxIbuQp6DqgxlscgftDwj6ZChahoF25NoGfJCi5un4tiNV0';

    const tokenOptions = { serviceWorkerRegistration: registration };
    if (vapidKey && vapidKey.length > 0) {
      tokenOptions.vapidKey = vapidKey;
    }

    const token = await getToken(messaging, tokenOptions);
    if (token && token.length > 0) {
      try {
        localStorage.setItem('web_fcm_token', token);
        localStorage.setItem('fcm_topic_all_clients', FCM_ALL_CLIENTS_TOPIC);
      } catch {
        // ignore
      }
      return token;
    }
    return '';
  } catch {
    return '';
  }
}

/**
 * مزامنة اختيارية مع الباك إند إذا وُجد مسار اشتراك (يُفضّل أن يستدعي subscribeToTopic على السيرفر).
 */
export async function syncPushSubscriptionWithBackend() {
  if (!SUBSCRIBE_ENDPOINT) {
    return;
  }
  const token = await getWebFcmToken();
  if (!token) {
    return;
  }
  try {
    await apiClient.post(SUBSCRIBE_ENDPOINT, {
      fcm_token: token,
      topic: FCM_ALL_CLIENTS_TOPIC,
    });
  } catch {
    // الاعتماد الأساسي يبقى على web_fcm_token في تسجيل الدخول
  }
}

/**
 * إشعارات أثناء فتح التبويب (foreground) — الخلفية تبقى على service worker.
 * يعيد دالة إلغاء الاشتراك.
 */
export async function registerForegroundMessageListener() {
  try {
    const { getMessaging, onMessage, isSupported } = await import(
      'firebase/messaging'
    );
    if (!(await isSupported())) {
      return () => {};
    }
    const messaging = getMessaging(app);
    return onMessage(messaging, (payload) => {
      const title =
        payload.notification?.title || payload.data?.title || 'إشعار جديد';
      const body = payload.notification?.body || payload.data?.body || '';
      showInfoToast(body ? `${title}: ${body}` : title);
      playNotificationSound();
    });
  } catch {
    return () => {};
  }
}
